import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ClubModel, DataListResponse } from '../models/app.models';

@Injectable({
  providedIn: 'root'
})
export class ClubService {
  private apiUrl = '/api/clubs';

  constructor(private http: HttpClient) { }

  getAll(page: number = 1, pageSize: number = 10, search?: string, sortField?: string, sortOrder?: number): Observable<DataListResponse<ClubModel>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (search) params = params.set('search', search);
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder) params = params.set('sortOrder', sortOrder.toString());

    return this.http.get<DataListResponse<ClubModel>>(`${this.apiUrl}/all`, { params }).pipe(
      map(res => ({
        ...res,
        data: res.data.map((club: ClubModel) => ({ ...club, name: club.name?.trim() }))
      }))
    );
  }

  searchClubs(query: string): Observable<ClubModel[]> {
    return this.http.get<ClubModel[]>(`${this.apiUrl}/search`, { params: { query } }).pipe(
      map(clubs => clubs.map((club: ClubModel) => ({ ...club, name: club.name?.trim() })))
    );
  }

  getAllSimple(): Observable<ClubModel[]> {
    return this.getAll(1, 10).pipe(
      map(res => res.data)
    );
  }

  getById(id: number): Observable<ClubModel> {
    return this.http.get<ClubModel>(`${this.apiUrl}/${id}`).pipe(
      map(club => ({ ...club, name: club.name?.trim() }))
    );
  }

  post(club: ClubModel): Observable<ClubModel> {
    return this.http.post<ClubModel>(this.apiUrl, club);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
